import React, { Component } from 'react';
import { Modal, Button, Table, Tabs } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const TabPane = Tabs.TabPane;

const tabs = [{
    tab:'已确认收入未开票',
    key:'accountsReceivableCl',
},{
    tab:'已开票未收款',
    key:'accountsReceivableEmpty',
}]

class UpdateLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        activeKey: 'accountsReceivableCl',
        pagination:{
            current:1,
            pageSize:10
        },
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record, pagination, activeKey } = this.state;
        const { current, pageSize } = pagination;
        const { investigationId, investigationJdeContractCode, actionPlan, estimatedCompletionTimeStr, nextNodeManager } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryModifyLogList,
            data: { 
                offset: current,
                limit: pageSize,
                investigationId, 
                jdeCode: investigationJdeContractCode,
                dataType: activeKey == 'accountsReceivableCl' ? 'AR_PLAN_REQUEST_FUNDS' : 'AR_PLAN_PAYMENT_COLLECTION',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res; 
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 120,
    }, {
        title: '更新人',
        dataIndex: 'modifyUser',
        key: 'modifyUser',
        width: 120,
        render: (text, record) => {
            const { modifyUserName, modifyUserCode } = record;
            return `${modifyUserName}[${modifyUserCode}]`
        }
    }, {
        title: '更新字段',
        dataIndex: 'fieldName',
        key: 'fieldName',
        width: 120,
    }, {
        title: '更新前',
        dataIndex: 'beforeValue',
        key: 'beforeValue',
        width: 120,
    }, {
        title: '更新后',
        dataIndex: 'afterValue',
        key: 'afterValue',
        width: 120,
    }]

    handleTabClick = (key) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            activeKey: key,
            pagination,
        },() => {
            this.loadData();
        })
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        },() => {
            this.loadData();
        })
    }

    render() {
        const { visible, loading, data, activeKey, pagination } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default UpdateLog;


// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/UpdateLog.js